import api from "../../../api";
import React from "react";
import utils from "../../../utils";
import values from "../../../values";
import Context from "../../../context";
import SuperAgentScreen from "../index";

import { TModal } from "../../../types/common.type";
import { useQuery } from "react-query";
import { DeleteModal } from "../../../components";
import {
  ICreateAndUpdateMunicipality,
  IFindUserInformation,
} from "../../../types/common.interface";

const MunicipalityCityContainer = () => {
  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Value Validations
  // ** --------------------------------------------------------------------------------------------------------------------

  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedSuperAgent, setSelectedSuperAgent] = React.useState<any>();
  const [requestSuperAgent, setRequestSuperAgent] =
    React.useState<IFindUserInformation>({
      page: 1,
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      search: { base: "", value: "" },
      filters: {
        province: undefined,
        city: undefined,
      },
    });
  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // !! ====================================================================================================================
  // !! --------------------------------------------------------------------------------------------------------------------
  // !!                                                Start API Cal
  // !! --------------------------------------------------------------------------------------------------------------------
  const resultMunicipality = useQuery(
    [
      values.useQueryKeys.getAllMunicipality,
      requestSuperAgent?.page,
      requestSuperAgent?.search?.value,
      requestSuperAgent?.filters,
    ],
    () =>
      api.post.administrator.getAllMuniciPality({
        filters: requestSuperAgent?.filters,
        search: requestSuperAgent?.search,
        limit: requestSuperAgent?.limit,
        page: requestSuperAgent?.page,
      })
  );

  // !! --------------------------------------------------------------------------------------------------------------------
  // !! ====================================================================================================================

  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Local Functions
  // ** --------------------------------------------------------------------------------------------------------------------
  async function createFunction(formData: ICreateAndUpdateMunicipality) {
    setIsLoading(true);
    const result = await api.post.administrator.createMunicipalityCity(
      formData
    );
    if (result) {
      utils.successHandler(Number(2010)); // result.CODE === 2021
      resultMunicipality.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  async function updateFunction(formData: ICreateAndUpdateMunicipality) {
    setIsLoading(true);
    const result = await api.put.administrator.updateMunicipality(formData);
    if (result) {
      utils.successHandler(Number(2010)); // result.CODE === 2021
      resultMunicipality.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  async function deleteFunction(userId: string) {
    setIsLoading(true);
    const result = await api.dele.administrator.deleteSuperAgent(userId);
    if (result) {
      utils.successHandler(Number(2010)); // result.CODE === 2021
      resultMunicipality.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // ?? ====================================================================================================================
  // ?? --------------------------------------------------------------------------------------------------------------------
  // ??                                                JSX Container
  // ?? --------------------------------------------------------------------------------------------------------------------
  return (
    <Context.MunicipulityScreen.Provider
      value={{
        showModal,
        isLoading,
        setShowModal,
        setIsLoading,
        updateFunction,
        createFunction,
        requestSuperAgent,
        selectedSuperAgent,
        setRequestSuperAgent,
        setSelectedSuperAgent,
      }}
    >
      <SuperAgentScreen rqSuperAgent={resultMunicipality} />
      <DeleteModal
        open={showModal === "DELETE"}
        user={selectedSuperAgent}
        data={selectedSuperAgent}
        loading={isLoading}
        onClose={() => setShowModal("NONE")}
        onSubmit={deleteFunction}
      />
    </Context.MunicipulityScreen.Provider>
  );

  // ?? --------------------------------------------------------------------------------------------------------------------
  // ?? ====================================================================================================================
};

export default MunicipalityCityContainer;
